/* Hotspots on the annotated product shot. One open at a time: clicking the
   open dot closes it, clicking another switches. */
window.lvWandInit = function (stageId) {
  var stage = document.getElementById(stageId);
  if (!stage || stage.dataset.lvInit) return;
  stage.dataset.lvInit = '1';

  var dots = [].slice.call(stage.querySelectorAll('[data-lv-wand-dot]'));
  var pops = [].slice.call(stage.querySelectorAll('[data-lv-wand-pop]'));
  if (!dots.length) return;

  function show(i) {
    for (var n = 0; n < dots.length; n++) {
      var on = String(n) === String(i);
      dots[n].classList.toggle('is-on', on);
      dots[n].setAttribute('aria-expanded', on ? 'true' : 'false');
      if (pops[n]) pops[n].classList.toggle('is-on', on);
    }
  }

  stage.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lv-wand-dot]');
    if (!b) return;
    var i = b.getAttribute('data-lv-wand-dot');
    show(b.classList.contains('is-on') ? -1 : i);
  });

  /* Escape closes, so a keyboard user is not stuck with a panel over the photo */
  stage.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') show(-1);
  });
};
